exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.claim-status[data-v-7540cb12] {\n    font-family: 'Allerta Stencil', sans-serif;\n    font-weight: bold;\n    font-size: 2.0em;\n}\n.status-button[data-v-7540cb12] {\n    opacity: 0;\n}\n.status-button[data-v-7540cb12]:hover {\n    opacity: 1;\n}\n.share-documents[data-v-7540cb12] {\n    position: relative;\n    top: 4px;\n    font-size: 1.25em;\n}\n.share-badge[data-v-7540cb12] {\n    position: relative;\n    top: -12px;\n    left: 12px;\n    display: inline-block;\n    font-size: .50em;\n}\n", ""]);

// exports
